const errorJson = {
    enabled: true,
    billManagement: "Bill Management",
    errorLoading: "There was an error loading the bill management page.",
}

export {
    errorJson
}
